export default __webpack_public_path__ + "static/media/logo.278b32db.png";